import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';
import banner from '../assets/images/banner.png';

const Home = () => {
  return (
    <div className="home">
      {/* Banner section */}
      <div className="banner-container" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)), url(${banner})` }}>
        <h2>Professional Paranormal Team</h2>
        <p>We investigate the paranormal so you don't have to</p>
        <div className="hero-btns">
          <Link to="/contact">
            <button className="btn">BOOK AN INVESTIGATION</button>
          </Link>
          <Link to="/about">
            <button className="btn btn-outline">LEARN MORE</button>
          </Link>
        </div>
      </div>

      {/* Expertise section */}
      <div className="home-section">
        {/* Empty section-tombstones div to maintain structure */}
        <div className="section-tombstones">
        </div>

        <h2>Our Expertise</h2>
        <div className="services-container">
          <div className="service-card">
            <div className="service-icon ghost-icon">👻</div>
            <h3>Paranormal Investigations</h3>
            <p>Professional investigation of haunted locations with state-of-the-art equipment.</p>
          </div>
          <div className="service-card">
            <div className="service-icon ghost-icon">🔍</div>
            <h3>Evidence Analysis</h3>
            <p>Thorough analysis of collected evidence with detailed reports of findings.</p>
          </div>
          <div className="service-card">
            <div className="service-icon ghost-icon">💡</div>
            <h3>Expert Opinions</h3>
            <p>Professional consultation and expert opinions on paranormal phenomena and experiences.</p>
          </div>
        </div>
      </div>

      {/* Featured investigation section */}
      <div className="home-section dark-section">
        {/* Empty section-tombstones div to maintain structure */}
        <div className="section-tombstones">
        </div>

        <h2>Featured Investigation</h2>
        <div className="featured-container">
          <div className="featured-content">
            <h3>The Abandoned Asylum</h3>
            <p>Our team spent a night at the notorious abandoned asylum, known for its dark history and paranormal activity. We captured EVPs, shadow figures, and unexplained temperature drops.</p>
            <Link to="/about">
              <button className="btn">READ THE FULL STORY</button>
            </Link>
          </div>
          <div className="featured-image">
            {/* Using the banner image for the featured investigation */}
            <img src={banner} alt="Abandoned Asylum Investigation" />
          </div>
        </div>
      </div>

      {/* Testimonials section */}
      <div className="home-section">
        {/* Empty section-tombstones div to maintain structure */}
        <div className="section-tombstones">
        </div>

        <h2>Testimonials</h2>
        <div className="testimonials-container">
          <div className="testimonial-card">
            <p>"The Black Cat team was professional and thorough. They helped us understand the strange occurrences in our home and provided us with peace of mind."</p>
            <h4>- Sarah Johnson</h4>
          </div>
          <div className="testimonial-card">
            <p>"I was skeptical at first, but after witnessing their investigation process and seeing the evidence they captured, I'm a believer. Highly recommend!"</p>
            <h4>- Michael Thompson</h4>
          </div>
          <div className="testimonial-card">
            <p>"They captured voices and images that cannot be explained. Their equipment and expertise are top-notch. A truly eye-opening experience."</p>
            <h4>- Emily Rodriguez</h4>
          </div>
        </div>
      </div>

      {/* CTA section */}
      <div className="cta-section" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${banner})` }}>
        {/* Empty section-tombstones div to maintain structure */}
        <div className="section-tombstones">
        </div>

        <h2>Ready to uncover the truth?</h2>
        <p>Book an investigation with Black Cat Paranormal team today</p>
        <Link to="/contact">
          <button className="btn btn-large">CONTACT US</button>
        </Link>
      </div>
    </div>
  );
};

export default Home;
